/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

/*
 * action types
 */
export const SIGN_UP_ACCOUNT_REQUEST = "SIGN_UP_ACCOUNT_REQUEST";
export const SIGN_UP_ACCOUNT_SUCCESS = "SIGN_UP_ACCOUNT_SUCCESS";
export const SIGN_UP_ACCOUNT_FAILURE = "SIGN_UP_ACCOUNT_FAILURE";
export const LOGOUT_ACCOUNT_REQUEST = "LOGOUT_ACCOUNT_REQUEST";
export const LOGOUT_ACCOUNT_SUCCESS = "LOGOUT_ACCOUNT_SUCCESS";
export const LOGIN_ACCOUNT_REQUEST = "LOGIN_ACCOUNT_REQUEST";
export const LOGIN_ACCOUNT_SUCCESS = "LOGIN_ACCOUNT_SUCCESS";
export const LOGIN_ACCOUNT_FAILURE = "LOGIN_ACCOUNT_FAILURE";
export const LOGIN_WITH_FACEBOOK_REQUEST = "LOGIN_WITH_FACEBOOK_REQUEST";
export const LOGIN_WITH_FACEBOOK_SUCCESS = "LOGIN_WITH_FACEBOOK_SUCCESS";
export const LOGIN_WITH_FACEBOOK_FAILURE = "LOGIN_WITH_FACEBOOK_FAILURE";
export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
export const CLEAR_ACCESS_TOKEN = "CLEAR_ACCESS_TOKEN";
export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const CLEAR_USER_NAME = "CLEAR_USER_NAME";
export const POST_FORGET_PASSWORD_REQUEST = "POST_FORGET_PASSWORD_REQUEST";
export const POST_FORGET_PASSWORD_SUCCESS = "POST_FORGET_PASSWORD_SUCCESS";
export const POST_FORGET_PASSWORD_FAILURE = "POST_FORGET_PASSWORD_FAILURE";
export const POST_RESET_PASSWORD_WITH_PHONE_REQUEST =
  "POST_RESET_PASSWORD_WITH_PHONE_REQUEST";
export const POST_RESET_PASSWORD_WITH_PHONE_SUCCESS =
  "POST_RESET_PASSWORD_WITH_PHONE_SUCCESS";
export const POST_RESET_PASSWORD_WITH_PHONE_FAILURE =
  "POST_RESET_PASSWORD_WITH_PHONE_FAILURE";
export const POST_RESET_PASSWORD_WITH_EMAIL_REQUEST =
  "POST_RESET_PASSWORD_WITH_EMAIL_REQUEST";
export const POST_RESET_PASSWORD_WITH_EMAIL_SUCCESS =
  "POST_RESET_PASSWORD_WITH_EMAIL_SUCCESS";
export const POST_RESET_PASSWORD_WITH_EMAIL_FAILURE =
  "POST_RESET_PASSWORD_WITH_EMAIL_FAILURE";
export const SET_PROFILE_STATUS = "SET_PROFILE_STATUS";
export const SET_LOGIN_PROFILE_STATUS = "SET_LOGIN_PROFILE_STATUS";
export const LINK_SOCIAL_NETWORK_REQUEST = "LINK_SOCIAL_NETWORK_REQUEST";
export const LINK_SOCIAL_NETWORK_SUCCESS = "LINK_SOCIAL_NETWORK_SUCCESS";
export const LINK_SOCIAL_NETWORK_FAILURE = "LINK_SOCIAL_NETWORK_FAILURE";

/*
 * action creators
 */
export const updateAccessToken = token => ({
  type: UPDATE_ACCESS_TOKEN,
  token
});

export const clearAccessToken = () => ({
  type: CLEAR_ACCESS_TOKEN
});

export const updateUserName = mobileNumber => ({
  type: UPDATE_USER_NAME,
  mobileNumber
});

export const clearUserName = () => ({
  type: CLEAR_USER_NAME
});

export const signUpAccountRequest = data => ({
  type: SIGN_UP_ACCOUNT_REQUEST,
  data
});

export const signUpAccountSuccess = (token, success) => ({
  type: SIGN_UP_ACCOUNT_SUCCESS,
  token,
  success
});

export const signUpAccountFailure = messages => ({
  type: SIGN_UP_ACCOUNT_FAILURE,
  messages
});

export const logoutAccountRequest = () => ({
  type: LOGOUT_ACCOUNT_REQUEST
});

export const logoutAccountSuccess = () => ({
  type: LOGOUT_ACCOUNT_SUCCESS
});

export const loginAccountRequest = (mobileNumber, password, rememberMe) => ({
  type: LOGIN_ACCOUNT_REQUEST,
  mobileNumber,
  password,
  rememberMe
});

export const loginAccountSuccess = token => ({
  type: LOGIN_ACCOUNT_SUCCESS,
  token
});

export const loginAccountFailure = messages => ({
  type: LOGIN_ACCOUNT_FAILURE,
  messages
});

export const loginWithFacebookRequest = fbAccessToken => ({
  type: LOGIN_WITH_FACEBOOK_REQUEST,
  fbAccessToken
});

export const loginWithFacebookSuccess = token => ({
  type: LOGIN_WITH_FACEBOOK_SUCCESS,
  token
});

export const loginWithFacebookFailure = messages => ({
  type: LOGIN_WITH_FACEBOOK_FAILURE,
  messages
});

export const postForgetPasswordRequest = phoneData => ({
  type: POST_FORGET_PASSWORD_REQUEST,
  phoneData
});

export const postForgetPasswordSuccess = data => ({
  type: POST_FORGET_PASSWORD_SUCCESS,
  data
});

export const postForgetPasswordFailure = () => ({
  type: POST_FORGET_PASSWORD_FAILURE
});

export const postResetPasswordWithPhoneRequest = resetData => ({
  type: POST_RESET_PASSWORD_WITH_PHONE_REQUEST,
  resetData
});

export const postResetPasswordWithPhoneSuccess = data => ({
  type: POST_RESET_PASSWORD_WITH_PHONE_SUCCESS,
  data
});

export const postResetPasswordWithPhoneFailure = () => ({
  type: POST_RESET_PASSWORD_WITH_PHONE_FAILURE
});

export const postResetPasswordWithEmailRequest = resetData => ({
  type: POST_RESET_PASSWORD_WITH_EMAIL_REQUEST,
  resetData
});

export const postResetPasswordWithEmailSuccess = () => ({
  type: POST_RESET_PASSWORD_WITH_EMAIL_SUCCESS
});

export const postResetPasswordWithEmailFailure = () => ({
  type: POST_RESET_PASSWORD_WITH_EMAIL_FAILURE
});

export const setProfileStatus = status => ({
  type: SET_PROFILE_STATUS,
  status
});

export const setLoginProfileStatus = status => ({
  type: SET_LOGIN_PROFILE_STATUS,
  status
});

export const linkSocialNetworkRequest = (channel, token) => ({
  type: LINK_SOCIAL_NETWORK_REQUEST,
  channel,
  token
});

export const linkSocialNetworkSuccess = user => ({
  type: LINK_SOCIAL_NETWORK_SUCCESS,
  user
});

export const linkSocialNetworkFailure = messages => ({
  type: LINK_SOCIAL_NETWORK_FAILURE,
  messages
});



// WEBPACK FOOTER //
// ./src/actions/auth.js